function getTimezoneOffsetInMs(): number {
	const date = new Date();
	return date.getTimezoneOffset() * 60000;
}

export default getTimezoneOffsetInMs;
